import Application from "../../Application";
import { IValueListService } from "../../service/valuelist/ValueListService";

export default class DeleteAttributeReferenceInteractor {
  private application: Application;
  private valueListService: IValueListService;

  constructor(application, valueListService) {
    this.application = application;
    this.valueListService = valueListService;
  }

  async execute(valueListItemId: number) {
    return this.valueListService.deleteValue(valueListItemId);
  }
}
